import {PermissionType} from '@hconnect/apiclient'
import {useMemo} from 'react'

import {usePlantConfig} from './usePlantConfig'

import {useLatestData} from '@settings/modules/common/hooks/useLatestData'
import {usePermissionsQuery} from '@settings/modules/permissions'
import {checkMultiplePermissions} from '@settings/modules/permissions/helpers/checkMultiplePermissions'
import {checkPermissionAccessByDataScope} from '@settings/modules/permissions/helpers/checkPermissionAccessByDataScope'
import {useUrlParam} from '@settings/modules/routing'

export const useOverridenMillIds = (plantUpmId?: string) => {
  const plantCode = useUrlParam('plantCode')
  const {data: userPermissions} = usePermissionsQuery()
  const {country} = useLatestData()

  const hasPermissions = useMemo(() => {
    const requiredPermissionTypes: PermissionType[] = ['VIEW_MATERIALS', 'CREATE_MASTER_DATA']
    return checkMultiplePermissions({
      permissions: userPermissions || [],
      requiredPermissionTypes,
      testFn: (permission) =>
        checkPermissionAccessByDataScope(country, plantCode, permission.parsedDataScope)
    })
  }, [userPermissions, country, plantCode])

  const {data: nodes, isLoading, isError} = usePlantConfig(plantUpmId, hasPermissions)

  const data = useMemo(() => {
    if (!nodes) return []

    return nodes
      .filter((config) =>
        config.payload.productionData.some((pd) => pd.name === 'overrideMillType' && !!pd.value)
      )
      .map((config) => config.metadata.typeUpmId)
  }, [nodes])

  return {
    data,
    isLoading,
    isError
  }
}
